import { Table, TableBody, TableCell, TableHead, TableRow, Button, Modal,Box } from '@mui/material';
import {Delete, Edit} from '@mui/icons-material';
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { deletePostById, getPosts } from './request';
import {Link} from 'react-router-dom';

const AdminPostList = ({accessToken}) => {
    const [posts, setPosts]  = useState([]);

    useEffect(() => {
        updatePosts();
    }, []);

    const updatePosts = async () => {
        setPosts(await getPosts({ accessToken }));
    };

    const onPostDelete = (_id)=>
        (async ()=>{
            await deletePostById({ accessToken, _id});
            await updatePosts();
        });

    return <div>
        <Table>
            <TableHead>
                <TableCell>My posts</TableCell>
            </TableHead>
            <TableBody>
            {posts.map((post, index)=>
                <TableRow>
                    <TableCell>{post.title}</TableCell>
                    <TableCell>{post.content.substring(0, 40)+'...'}</TableCell>
                    <TableCell><Link to={'/edit-post/'+post._id}><Edit /></Link></TableCell>
                    <TableCell><Button onClick={onPostDelete(post._id)}><Delete /></Button></TableCell>
                </TableRow>)
            }
            </TableBody>
        </Table>
    </div>;
};

const mapStateToProps = (state) => ({
    accessToken: state.user.accessToken
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPostList);
